import { supabase } from './supabase'

export async function uploadRefuelPhoto(file: File, path: string): Promise<string | null> {
  try {
    console.log(`Uploading file to refuel-photos bucket with path: ${path}`)

    const { data, error } = await supabase.storage
      .from('refuel-photos')
      .upload(path, file, { upsert: true })

    if (error) {
      console.error('Failed to upload refuel photo:', error)
      // Log error details  
      console.error('Error details:', error)
      return null
    }

    // Get public URL
    const publicUrlResult = supabase.storage.from('refuel-photos').getPublicUrl(path)
    console.log(`Photo uploaded successfully: ${publicUrlResult.data.publicUrl}`)
    return publicUrlResult.data.publicUrl || null

  } catch (err) {
    console.error('Exception during photo upload:', err)
    return null
  }
}

export async function uploadVoucherPhoto(file: File, path: string): Promise<string | null> {
  try {
    console.log(`Uploading voucher file to refuel-photos bucket with path: ${path}`)

    const { data, error } = await supabase.storage
      .from('refuel-photos')
      .upload(path, file, { upsert: true })

    if (error) {
      console.error('Failed to upload voucher photo:', error)
      console.error('Error details:', error)
      return null
    }

    // Get public URL
    const publicUrlResult = supabase.storage.from('refuel-photos').getPublicUrl(path)
    console.log(`Voucher photo uploaded successfully: ${publicUrlResult.data.publicUrl}`)
    return publicUrlResult.data.publicUrl || null

  } catch (err) {
    console.error('Exception during voucher photo upload:', err)
    return null
  }
}

export async function uploadSlipPhoto(file: File, path: string): Promise<string | null> {
  try {
    console.log(`Uploading slip file to refuel-photos bucket with path: ${path}`)

    const { data, error } = await supabase.storage
      .from('refuel-photos')
      .upload(path, file, { upsert: true })

    if (error) {
      console.error('Failed to upload slip photo:', error)
      console.error('Error details:', error)
      return null
    }

    // Get public URL
    const publicUrlResult = supabase.storage.from('refuel-photos').getPublicUrl(path)
    console.log(`Slip photo uploaded successfully: ${publicUrlResult.data.publicUrl}`)
    return publicUrlResult.data.publicUrl || null

  } catch (err) {
    console.error('Exception during slip photo upload:', err)
    return null
  }
}
